import { useEffect, useState } from "react";
import { useAuth } from "@/lib/auth";
import { Coins } from "lucide-react";

const PRESETS = [10, 50, 100, 500, 1000];

export default function WagerPanel({ game, onStart, busy, min = 10 }) {
  const { user } = useAuth();
  const [wager, setWager] = useState(50);

  useEffect(() => {
    if (wager > (user?.chips || 0)) setWager(Math.max(min, Math.min(50, user?.chips || 0)));
  }, [user, wager, min]);

  const can = (user?.chips || 0) >= wager && wager >= min;

  return (
    <div className="vexis-card p-5">
      <div className="flex items-center justify-between">
        <div>
          <div className="pill">Wager</div>
          <div className="mt-2 font-display text-3xl text-[color:var(--gold)]" data-testid="wager-amount">{wager.toLocaleString()}</div>
          <div className="text-xs text-slate-500 font-mono mt-1">chips</div>
        </div>
        <div className="text-right">
          <div className="text-[11px] font-mono uppercase tracking-widest text-slate-500">Balance</div>
          <div className="font-mono text-slate-300 flex items-center gap-1 justify-end"><Coins className="w-3.5 h-3.5 text-[color:var(--gold)]" /> {user?.chips?.toLocaleString?.() ?? 0}</div>
        </div>
      </div>
      <div className="flex flex-wrap gap-2 mt-4">
        {PRESETS.map((p) => (
          <button key={p} onClick={() => setWager(p)} data-testid={`wager-preset-${p}`}
            className={`px-3 py-1.5 rounded-full text-sm border transition ${wager === p ? "border-[color:var(--gold)] text-[color:var(--gold)] bg-[rgba(226,185,106,0.08)]" : "border-white/10 text-slate-400 hover:text-white"}`}>{p}</button>
        ))}
        <input type="number" min={min} max={user?.chips || 0} value={wager}
          onChange={(e) => setWager(Math.max(min, Math.min(user?.chips || 0, parseInt(e.target.value || "0"))))}
          className="vexis w-24 text-sm" data-testid="wager-input" />
      </div>
      <button className="btn-gold mt-5 w-full" disabled={!can || busy} onClick={() => onStart(wager)} data-testid="wager-start">
        {busy ? "Dealing…" : `Start ${game} · Stake ${wager}`}
      </button>
      {!can && <div className="text-xs text-red-400 mt-2" data-testid="wager-err">Not enough chips.</div>}
    </div>
  );
}
